<template>
    <div class="zebra-crossing-detail">
        <!--  表单明细 -->
        <el-form :model="detail.configProperties">
            <div class="zebra-item">

                <!-- 结构  MAC地址 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="结构：">{{ detail.configProperties.structure }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="MAC地址：">{{ detail.configProperties.mac}}</el-form-item>
                    </el-col>
                </el-row>
                <!--IP地址-->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="IP地址：">{{  detail.configProperties.ip}}</el-form-item>
                    </el-col>


                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">处理器</div>
                <!-- 类型 型号 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="类型：">{{ detail.configProperties.cpuType }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="型号：">{{  detail.configProperties.cpuModel}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 频率 标配数量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="频率：">{{  detail.configProperties.cpuFrequency}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="标配数量：">{{detail.configProperties.cpuStandardizedQuantity}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 最大数量 制程工艺 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="最大数量：">{{ detail.configProperties.cpuMaxQuantity}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="制程工艺：">{{  detail.configProperties.cpuManufacturing}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 三级缓存 总线规格 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="三级缓存：">{{   detail.configProperties.level3Cache}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="总线规格：">{{ detail.configProperties.cpuBus}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 核心数 线程数 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="核心数：">{{ detail.configProperties.cpuCoreNum}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="线程数：">{{detail.configProperties.cpuThreadNum}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>
                <div class="zebra-item_tit">主板</div>
                <!-- 芯片组 扩展槽 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="芯片组：">{{ detail.configProperties.motherboardsChip}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="扩展槽：">{{detail.configProperties.motherboardsExpansionSlot }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">内存</div>

                <!-- 类型 容量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="类型：">{{detail.configProperties.memoryType}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="容量：">
                            {{detail.configProperties.memorySize}}
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 最大容量 插槽数量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="最大容量：">
                            {{detail.configProperties.memoryMaxSize}}
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="插槽数量：">
                            {{detail.configProperties.memoryExpansionSlotNum}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">存储</div>
                <!-- 硬盘接口类型  硬盘容量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="硬盘接口类型：">
                            {{detail.configProperties.diskType}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="硬盘容量：">
                            {{detail.configProperties.diskSize}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--硬盘描述  内部硬盘架数-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="硬盘描述：">
                            {{detail.configProperties.diskDescribe}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="内部硬盘架数：">
                            {{detail.configProperties.diskRack}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--热拔插盘位  RAID模式-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="热拔插盘位：">
                            {{detail.configProperties.diskHotSwap}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="RAID模式：">
                            {{detail.configProperties.diskRAID}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--磁盘控制器  光驱-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="磁盘控制器：">
                            {{detail.configProperties.diskControl}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="光驱：">
                            {{detail.configProperties.CDDrive}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">网络</div>
                <!--网络控制器 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="网络控制器：">
                            {{detail.configProperties.network}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">电源性能</div>
                <!--类型  数量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="类型：">
                            {{detail.configProperties.powerType}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="数量：">
                            {{detail.configProperties.powerNum}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="功率：">
                            {{detail.configProperties.powerPower}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">外观特征</div>
                <!--尺寸  重量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="尺寸：">
                            {{detail.configProperties.appearanceSize}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="重量：">
                            {{detail.configProperties.appearanceWeight}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">适用环境</div>
                 <!--工作温度  工作湿度 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="工作温度：">
                            {{detail.configProperties.workingTemperature}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作湿度：">
                            {{detail.configProperties.workingHumidity}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--存储温度  存储湿度 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="存储温度：">
                            {{detail.configProperties.storageTemperature}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="存储湿度：">
                            {{detail.configProperties.storageHumidity}}
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 附件 -->

            </div>
        </el-form>
    </div>
</template>

<script>
    export default {

        props: {
            detail: Object,
        },

        computed:{
            // // 字典
            // dictionary() {
            //     return this.$store.state.dictionary;
            // },
            // //资产类型
            // cmdbAssetType() {
            //     return this.dictionary.cmdb_asset_type;
            // },
            // //环境类型
            // envType() {
            //     return this.dictionary.env_type;
            // },
            // // 品牌
            // brand() {
            //     return this.dictionary.brand;
            // },
            // // 供应商
            // supplier() {
            //     return this.dictionary.supplier;
            // },
            // // 所在位置
            // location() {
            //     return this.dictionary.location;
            // },
        },
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
